import {Injectable} from '@angular/core';
import {TtWorkingTimeEntry} from '../../interfaces/time-tracking/tt-working-time-entry';
import {StaticTable} from '../static.table';
import {db} from '../db.service';
import {DateTime, Interval} from 'luxon';
import {TimeHelper} from '../../helpers/time-helper';

@Injectable({
  providedIn: 'root'
})
export class TtWorkingTimeEntriesTable extends StaticTable<TtWorkingTimeEntry> {
  /**
   *
   */
  constructor() {
    super(db.ttWorkingTimeEntries);
  }


  /**
   *
   * @private
   */
  public async removeByDate(date: string | DateTime): Promise<void> {
    if(typeof (date) === 'string') {
      date = DateTime.fromISO(date);
    }

    let ttWorkingTimeEntries = await this.getAll();
    const ttWorkingTimeEntriesIds = ttWorkingTimeEntries.filter(_ttWorkingTimeEntry => {
      const timeFrom = DateTime.fromISO(_ttWorkingTimeEntry.timeFrom);
      return timeFrom.hasSame(date, 'day');
    }).map(_ttWorkingTimeEntry => _ttWorkingTimeEntry.id);

    await this.removeMany(ttWorkingTimeEntriesIds);
  }


  /**
   *
   * @param dateFrom
   * @param dateTo
   */
  public async removeByPeriod(dateFrom: DateTime, dateTo: DateTime): Promise<void> {
    const ttWorkingTimeEntries = await this.getAll();
    const _dateFrom = dateFrom.toISODate();
    const _dateTo = dateTo.toISODate();

    const ttWorkingTimeEntriesIds = ttWorkingTimeEntries.filter(_ttWorkingTimeEntry => {
      return _ttWorkingTimeEntry.timeFrom.substring(0, 10) >= _dateFrom && _ttWorkingTimeEntry.timeFrom.substring(0, 10) <= _dateTo;
    }).map(_ttWorkingTimeEntry => _ttWorkingTimeEntry.id);

    await this.removeMany(ttWorkingTimeEntriesIds);
  }

  /**
   *
   */
  public override async getAll(): Promise<TtWorkingTimeEntry[]> {
    return this.table.orderBy('timeFrom').toArray();
  }

  /**
   *
   * @param date
   * @param dateTo
   */
  public async getByPeriod(date: DateTime | Date | string, dateTo: DateTime | Date | string): Promise<TtWorkingTimeEntry[]> {
    date = TimeHelper.getDateString(date);
    dateTo = TimeHelper.getDateString(dateTo);

    let ttWorkingTimeEntries = await this.getAll();

    ttWorkingTimeEntries = ttWorkingTimeEntries.filter(_ttWorkingTimeEntry => {
      const timeFrom = _ttWorkingTimeEntry.timeFrom.substring(0, 10);

      if(date && !dateTo) {
        return timeFrom === date;
      }
      else {
        return timeFrom >= date && timeFrom <= dateTo;
      }
    });

    return ttWorkingTimeEntries;
  }

}
